/**
 * Agence'O - js-sticky-share
 * @author Axel Baron (Agence'O)
 * @created 15/05/2019
 */

(function ($) {

  $(document).on('click', '.js-sticky-share', (e) => {
    e.preventDefault();
    e.stopPropagation();
    let stickyModule = $(e.currentTarget).parent();
    let content = stickyModule.find('.sticky-share__content');

    content.stop().slideToggle();
    stickyModule.toggleClass('open');
  });

}(jQuery));
